
import "../styles/hivemind.css";
import React, { useMemo, useState } from "react";
import useScenario from "../hooks/useScenario";
import useHiveMind from "../hooks/useHiveMind";
import MapView from "./MapView";
import { HiveAPI } from "../api/hivemind";

export default function HiveMindHome() {
  const { map, loading: mapLoading } = useScenario();
  const { moves, participants, loading, refresh } = useHiveMind(map?.id);
  const [inviteList, setInviteList] = useState("");

  const positions = useMemo(() => moves.filter((m) => m.type === "position"), [moves]);

  async function handlePostMove(payload) {
    await HiveAPI.postMove(map.id, payload);
    await refresh();
  }

  async function sendInvites() {
    const emails = inviteList.split(",").map((s) => s.trim()).filter(Boolean);
    if (!emails.length) return;
    await HiveAPI.invite(emails);
    setInviteList("");
    alert(`Invited ${emails.length} people.`);
  }

  if (mapLoading || loading) return <div style={{ padding: 16 }}>Loading…</div>;

  return (
    <div className="hm-board grid-3col">
      {/* Left rail */}
      <aside className="hm-rail left">
        <div className="hm-card">
          <h4 className="rail-title">Participants</h4>
          <div className="chip cloud">
            {participants.length ? participants.join(" · ") : "No participants yet."}
          </div>
        </div>

        <div className="hm-card">
          <h4 className="rail-title">Invite</h4>
          <input value={inviteList} onChange={(e) => setInviteList(e.target.value)} placeholder="a@x.com, b@y.com" />
          <button className="btn primary" onClick={sendInvites}>Send</button>
        </div>
      </aside>

      {/* Center */}
      <main className="hm-main">
        <header className="hm-header">
          <div>
            <div className="chip t-issue">Scenario of the Day</div>
            <h2 className="hm-title">{map.title}</h2>
          </div>
          <div className="hm-head-actions">
            <button className="btn outline" onClick={refresh} title="Refresh">↻</button>
          </div>
        </header>

        <MapView
          map={map}
          moves={moves}
          onVote={(id, kind) => HiveAPI.vote(id, kind).then(refresh)}
          onPost={handlePostMove}
        />
      </main>

      {/* Right rail */}
      <aside className="hm-rail right">
        <div className="hm-card">
          <h4 className="rail-title">Filters & Legend</h4>
          <div className="legend">
            {["issue", "position", "for", "against", "risk", "evidence"].map((t) => (
              <div key={t} className="legend-row"><span className={`dot t-${t}`} /> {t}</div>
            ))}
          </div>
        </div>
      </aside>
    </div>
  );
}
